import React from "react";
import { Volume2, VolumeX } from "lucide-react";
import useAmbientSound from "../hooks/useAmbientSound";

/** Looping background track (public/assets). */
const AMBIENT_TRACK = "/assets/ambient2.mp3";

const AmbientSoundToggle: React.FC = () => {
  const { enabled, isPlaying, isAvailable, toggle } = useAmbientSound(AMBIENT_TRACK);

  // No track shipped (or it failed to load) — don't show a dead control.
  if (!isAvailable) return null;

  // Sound is wanted but the browser hasn't allowed it yet: this click is the
  // user gesture that starts playback, so it must not flip the preference off.
  const isAwaitingGesture = enabled && !isPlaying;
  const isAudible = enabled && isPlaying;

  const handleClick = () => {
    if (isAwaitingGesture) return;
    toggle();
  };

  const title = isAwaitingGesture
    ? "Tap to start the background sound"
    : isAudible
      ? "Mute background sound"
      : "Play background sound";

  return (
    <button
      type="button"
      className={`icon-item sound-toggle${isAudible ? "" : " sound-toggle--muted"}`}
      onClick={handleClick}
      aria-pressed={isAudible}
      aria-label={isAudible ? "Mute background sound" : "Play background sound"}
      title={title}
    >
      {isAudible ? (
        <Volume2 className="icon-svg" />
      ) : (
        <VolumeX className="icon-svg" />
      )}
      <span className="icon-label">{isAudible ? "Sound" : "Muted"}</span>
    </button>
  );
};

export default AmbientSoundToggle;
